import { Deserializable } from '../interfaces';

export class SocialNetwork implements Deserializable {
  descripcion: string;
  idRedSocial: number;

  constructor() {
    this.descripcion = '';
    this.idRedSocial = 0;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
